import ROLES from '../constants/roles';

export const isUserAdmin = (roleId?: number): boolean => {
  if (!roleId) return false;
  return [ROLES.SUPER_ADMIN, ROLES.TENANT_ADMIN].includes(roleId);
};
